import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { started: String };

  static targets = ['timerRow', 'countdownHours', 'countdownMinutes', 'countdownSeconds'];

  connect() {
    if (this.startedValue) {  
      this.updateTimer();
      this.updateActiveTimers();
      this.startInterval();
    }
  }

  disconnect() {
    clearInterval(this.interval);
  }

  startInterval() {
    this.interval = setInterval(() => {
      this.updateTimer();
      this.updateActiveTimers();
    }, 1000);
  }

  countdown(targetDate, callback) {
    let diff = Math.max(new Date() - targetDate, 0);

    callback({
      hours: Math.floor(diff / (1000 * 60 * 60)),
      minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((diff % (1000 * 60)) / 1000),
    });
  }

  updateTimer() {
    this.countdown(new Date(this.startedValue), (ts) => {
      if (this.hasCountdownHoursTarget) {
        this.countdownHoursTarget.textContent = ts.hours || 0;
        this.countdownMinutesTarget.textContent = ts.minutes || 0;
        this.countdownSecondsTarget.textContent = ts.seconds || 0;
      }
    });
  }

  updateActiveTimers() {
    if (this.startedValue && this.hasTimerRowTarget) {
      this.countdown(new Date(this.startedValue), (ts) => {
        const text = `${ts.hours || 0} hours ${ts.minutes || 0} minutes ${ts.seconds || 0} seconds`;
        this.timerRowTarget.querySelector('.time-countdown').textContent = text;
      });
    }
  }
}
